import React, {Component} from 'react';
import {connect} from 'react-redux'
import {bindActionCreators} from 'redux'
import {Link, Redirect} from 'react-router-dom'
import { Col, Button, Card, CardBlock, CardSubtitle, Row, Container } from 'reactstrap';

import {loginUser, logoutUser} from '../../actions/userActions'

class UserPage extends Component {
  handleSubmit = (e) => {
    e.preventDefault();
    let {loginUser} = this.props
    let data = new FormData(document.querySelector('#login-form'));

    loginUser(data);
  }

  render() {
    let {login} = this.props.userState
    let {logoutUser} = this.props
    sessionStorage.removeItem("btn_ok")
    sessionStorage.setItem("shop_ok", "ok");
  
    return (

      <div>
        <Container>
        {login.isLogin ? null : <Redirect to='/login'/>}
        <h1>Votre compte</h1>

        <Row className="page-user">
          <Col  sm="4" className="mb-4">
            <Card style={{height: 100, backgroundColor: "rgb(161 155 155 / 9%)", border:"none"}}>  
              <CardBlock>
                <CardSubtitle className="text-center ">
                  <Link to="registration/edit" style={{color:"#637375", "text-decoration":"none"}}>
                  <i className="fa fa-user fa-3x" style={{color:"rgb(0 159 255 / 64%)"}}></i><br/>
                  <span>INFORMATIONS</span></Link>
                </CardSubtitle>
              </CardBlock>
            </Card>
          </Col>
          <Col  sm="4">
            <Card style={{height: 100, backgroundColor: "rgb(161 155 155 / 9%)", border:"none"}}>  
              <CardBlock>
                <CardSubtitle className="text-center">
                  <Link to="addresse" style={{color:"#637375", "text-decoration":"none"}}>
                  <i className="fa fa-map-marker fa-3x" style={{color:"rgb(0 159 255 / 64%)"}}></i><br/>
                  <span>AJOUTER UNE PREMIERE ADRESSE</span></Link>
                </CardSubtitle>
              </CardBlock>
            </Card>
          </Col>
          <Col  sm="4">
            <Card style={{height: 100, backgroundColor: "rgb(161 155 155 / 9%)", border:"none"}}>  
              <CardBlock>
                <CardSubtitle className="text-center">
                  <Link to="download" style={{color:"#637375", "text-decoration":"none"}}>
                  <i className="fas fa-download" style={{color:"rgb(0 159 255 / 64%)","font-size":"45"}}></i><br/>
                  <span>TELECHARGEMENT DE DOCUMENT</span></Link>
                </CardSubtitle>
              </CardBlock>
            </Card>
          </Col>
        </Row>

        
          <div className="text-center btn-logout">
            <Button onClick={logoutUser} style={{color:"rgb(0 159 255 / 64%)"}}>Déconnexion <i className="fa fa-sign-out" style={{color:"#8a6d3b"}}></i></Button>
          </div>
          
       </Container> 
      </div>
    );
  }
}


function mapStateToProps({userReducer}) {
  return {
    userState: userReducer
  }
}
function mapDispatchToProps(dispatch) {
  return {
    loginUser : bindActionCreators(loginUser, dispatch),
    logoutUser: bindActionCreators(logoutUser, dispatch),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(UserPage);


// WEBPACK FOOTER //
// ./src/containers/User/UserPage.js